import type { ContactFormDto } from '@eneco/dc-be/client';

import type { CancelOrderValues } from './CancelOrder';

interface PostContactForm {
  (options: { body: ContactFormDto }): Promise<{ response: Response }>;
}

interface CancelOrderSubjectFields {
  language?: ContactFormDto['language'];
  subject?: string | null;
  subLevelSubject?: string | null;
  lastName?: string;
}

export const submitCancelOrder = async (
  values: CancelOrderValues,
  postContactForm: PostContactForm,
  subjectFields: CancelOrderSubjectFields = {},
): Promise<void> => {
  const lastName = subjectFields.lastName ?? values.lastNameOrderId;
  const {
    lastNameOrderId: _lastNameOrderId,
    isApiPostalCodeCityValid: _isApiPostalCodeCityValid,
    recaptchaToken: _recaptchaToken,
    ...questionValues
  } = {
    ...values,
    dateTime: new Date().toISOString(),
  };
  void _lastNameOrderId;
  void _isApiPostalCodeCityValid;
  void _recaptchaToken;
  const { response } = await postContactForm({
    body: {
      attachments: [],
      customerNumber: values.customerNumber,
      email: values.email,
      firstName: values.firstName,
      language: subjectFields.language ?? 'DUTCH',
      lastName,
      question: JSON.stringify({ ...questionValues, lastName }),
      street: values.street,
      streetNumber: values.houseNumber,
      subject: subjectFields.subject ?? 'Contract en Tarieven',
      subLevelSubject: subjectFields.subLevelSubject ?? 'Contract herroepen',
      telephone: values.phoneNumber,
      zipCode: values.zipCode,
    },
  });

  if (!response.ok) {
    throw new Error('request failed');
  }
};
